import OrderCard from '../cards/OrderCard'
import css from './OrdersGrid.module.scss'

export default function OrderGrid({ orders, handleDetails, handleCancel }) {
	return (
		<div className={css['grid']}>
			{orders.map(order => {
				return (
					<OrderCard
						handleDetails={handleDetails}
						handleCancel={handleCancel}
						{...order}
						key={order._id}
					/>
				)
			})}
		</div>
	)
}
